import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import { NotifierProvider } from './components/Notifier';
import NetworkErrorBackdrop from 'components/NetworkErrorBackdrop';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { LanguageProvider } from './utils/i18n';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';
window.addEventListener('vite:preloadError', (event) => {
  window.location.reload();
});
// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  useEffect(() => {
    const updateTitleAndFavicon = () => {
      try {
        const rawAppSetting = localStorage.getItem('appSetting');
        if (rawAppSetting) {
          const appSetting = JSON.parse(rawAppSetting);
          if (appSetting?.web_attribution?.title) {
            if (document.title !== appSetting.web_attribution.title) {
              document.title = appSetting.web_attribution.title;
            }
            const metaTitle = document.querySelector('meta[name="title"]');
            if (metaTitle && metaTitle.getAttribute('content') !== appSetting.web_attribution.title) {
              metaTitle.setAttribute('content', appSetting.web_attribution.title);
            }
          }
          if (appSetting?.web_attribution?.favicon) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            if (link.href !== appSetting.web_attribution.favicon) {
              link.href = appSetting.web_attribution.favicon;
            }
          }
        }
      } catch (e) {
        console.error('Failed to parse appSetting from localStorage', e);
      }
    };

    updateTitleAndFavicon();
    const intervalId = setInterval(updateTitleAndFavicon, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <LanguageProvider>
        <ThemeCustomization>
          <RTLLayout>
            <Locales>
              <ScrollTop>
                <AuthProvider>
                  <NotifierProvider>
                    <Notistack>
                      <RouterProvider router={router} />
                      <Snackbar />
                      <NetworkErrorBackdrop />
                    </Notistack>
                  </NotifierProvider>
                </AuthProvider>
              </ScrollTop>
            </Locales>
          </RTLLayout>
        </ThemeCustomization>
      </LanguageProvider>
    </LocalizationProvider>
  );
}
